import { FunctionComponent, useEffect, useState } from "react";

interface NewsItem {
  id: string;
  date: string;
  title: string;
  body: string;
  createdAt: number | null;
}

type NewsPanelProps = { onClose: () => void };

const NewsPanel: FunctionComponent<NewsPanelProps> = ({ onClose }) => {
  const [items, setItems] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/news")
      .then((r) => r.ok ? r.json() : Promise.reject(new Error(String(r.status))))
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="Overlay" onClick={onClose}>
      <div className="Modal News-modal" onClick={(e) => e.stopPropagation()}>
        <div className="Modal-header">
          <div className="Modal-title">Новости</div>
          <button className="Modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="News-list">
          {loading && <div className="Admin-loading">Загрузка...</div>}
          {!loading && items.length === 0 && (
            <div className="Admin-empty">Новостей пока нет</div>
          )}
          {items.map((n) => (
            <div key={n.id} className="News-item">
              <div className="News-date">{n.date}</div>
              <div className="News-title">{n.title}</div>
              <div className="News-body">{n.body}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsPanel;
